import React from "react";
import styled from "@emotion/styled";
import { Card as MuiCard, CardHeader, CardContent, Typography, Box, Chip } from "@mui/material";
import { MoreVertical, Info } from "react-feather";

const StyledCard = styled(MuiCard)`
  border-radius: 16px;
  box-shadow: ${(props) =>
    props.theme.palette.mode === "dark"
      ? "0 4px 20px rgba(0, 0, 0, 0.4)"
      : "0 4px 20px rgba(0, 0, 0, 0.05)"};
  border: 1px solid
    ${(props) =>
      props.theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)"};
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.palette.background.paper};
  overflow: hidden;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: ${(props) =>
      props.theme.palette.mode === "dark"
        ? "0 8px 30px rgba(0, 0, 0, 0.6)"
        : "0 8px 30px rgba(0, 0, 0, 0.08)"};
  }
`;

const RadiusBadge = styled(Chip)`
  background-color: ${(props) => (props.theme.palette.mode === "dark" ? "#1e3a8a" : "#eff6ff")};
  color: ${(props) => (props.theme.palette.mode === "dark" ? "#60a5fa" : "#3b82f6")};
  font-weight: 800;
  font-size: 10px;
  height: 20px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-left: 8px;
`;

const ProCard = ({ title, showBadge = false, children, ...rest }) => {
  return (
    <StyledCard {...rest}>
      <Box
        sx={{
          p: 4,
          pb: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 700, color: "text.secondary", textTransform: "capitalize" }}
          >
            {title}
          </Typography>
          {showBadge && <RadiusBadge label="RADIUS" />}
          <Box sx={{ ml: 1, display: "flex", alignItems: "center", cursor: "pointer" }}>
            <Info size={14} color="#94a3b8" />
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 1, cursor: "pointer", color: "#94a3b8" }}>
          <MoreVertical size={18} />
        </Box>
      </Box>
      <CardContent sx={{ flexGrow: 1, p: "16px !important" }}>{children}</CardContent>
    </StyledCard>
  );
};

export default ProCard;
